module.exports = __webpack_public_path__ + "img/listClient.ff266725.png";